import "./Test.css"
function Test(){

    return(
        <>  
            <div className="testcontainer">
                <h1 className="h1A">A</h1>
                <div className="line"></div>
                <h1 className="h1B">B</h1>
            </div>
        </>
    )
}

export default Test